// @ts-strict-ignore
import { useState } from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import { Modal } from 'reactstrap';
import i18n from 'src/utils/translate';
import Icon from 'src/components/icon';
import Button from 'src/components/buttons/button';
import { textSmall } from 'styles-js/mixins/typography';
import ImagePlaceMarker from 'src/modules/community/singlePost/components/imagePlaceMarker';
import { useSelector } from 'src/store/store';
import { ResponsiveImageUnknownSize } from 'src/components/responsiveImage';
type Props = {
  src: string;
  previewSrc: string;
  alt: string;
};
export default function ReplyImage({
  src,
  previewSrc,
  alt
}: Props) {
  const {
    communityId
  } = useSelector(state => state.context.currentCommunity);
  const [shouldDisplayImageModal, setShouldDisplayImageModal] = useState(false);
  if (!src || !previewSrc) return null;
  return <ImagePlaceMarker communityId={communityId} data-sentry-element="ImagePlaceMarker" data-sentry-component="ReplyImage" data-sentry-source-file="replyImage.tsx">
      <PreviewImage data-sentry-element="PreviewImage" data-sentry-source-file="replyImage.tsx">
        <FullscreenButton ariaLabel="View the image in full screen mode" dataTestId="fullscreen-button" type="none" onClick={() => setShouldDisplayImageModal(true)} data-sentry-element="FullscreenButton" data-sentry-source-file="replyImage.tsx">
          <Image alt={alt} height={240} src={previewSrc} unoptimized={true} width={320} data-sentry-element="Image" data-sentry-source-file="replyImage.tsx" />
          <FullscreenIcon icon="zoom-in" data-sentry-element="FullscreenIcon" data-sentry-source-file="replyImage.tsx" />
        </FullscreenButton>
        {alt && <Caption>{alt}</Caption>}
      </PreviewImage>

      {shouldDisplayImageModal && <ImageModal external={<CloseButton icon="close" iconPosition="right" text={i18n.t('Close')} type="secondary" onClick={() => setShouldDisplayImageModal(false)} />} isOpen={shouldDisplayImageModal}>
          <ResponsiveImageUnknownSize fill alt={alt} src={src} unoptimized={true} />
        </ImageModal>}
    </ImagePlaceMarker>;
}
const PreviewImage = styled.div`
  display: inline-block;
  margin-bottom: 30px;
  border: ${({
  theme
}) => theme.greyLine};
`;
const FullscreenButton = styled(Button)`
  position: relative;
  padding: 0;
  border: none;
  border-radius: 0;
  overflow: hidden;

  &:hover, &:focus, &:active {
    span {
      border-color: ${({
  theme
}) => theme.colorBlue};
    }
  }
`;
const FullscreenIcon = styled(Icon)`
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px 8px 7px;
  border-radius: 4px;
  border: ${({
  theme
}) => theme.greyLine};
  background-color: ${({
  theme
}) => theme.colorWhite};
  box-shadow: ${({
  theme
}) => theme.shadowLight};
  font-size: 22px;
  transition: all 0.5s ease;
`;
const Caption = styled.span`
  display: block;
  padding: 10px;
  ${textSmall};
  color: ${({
  theme
}) => theme.colorGreyDark};
`;
const ImageModal = styled(Modal)`
  .modal &.modal-dialog {
    max-width: none;
    margin: 0;
  }

  .modal-content {
    background-color: transparent;
    background-clip: border-box;
    border: none;

    height: calc(100vh - 75px);
    margin: 60px auto 15px;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  img {
    max-width: 100vw;
    max-height: calc(100vh - 75px);
  }
`;
const CloseButton = styled(Button)`
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0;
  z-index: ${({
  theme
}) => theme.zindexLiftTop};
`;